import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { mapKeys } from "../util/object.js";
var applyMapping = function applyMapping(mapping) {
  return function (key) {
    return key in mapping ? mapping[key] : key;
  };
};
export var mappedTranslate = function mappedTranslate(translate) {
  var codeMapping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var dataMapping = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return function (code) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var mappedCode = applyMapping(codeMapping)(code);
    var mappedData = mapKeys(data, applyMapping(dataMapping));
    return translate(mappedCode, mappedData);
  };
};
export var normalizeLocale = function normalizeLocale(locale) {
  var _split = (locale || "").split("-"),
    _split2 = _slicedToArray(_split, 2),
    lang = _split2[0],
    region = _split2[1];
  return lang && region ? lang.toLowerCase() + "_" + region.toUpperCase() : undefined;
};
export var localeToLang = function localeToLang(locale) {
  var _split3 = (locale || "").split("-"),
    _split4 = _slicedToArray(_split3, 1),
    lang = _split4[0];
  return lang ? lang.toLowerCase() : undefined;
};